import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../http";
import Captcha from "./Captcha/Captcha";
import HeaderWrapper from "./Header/HeaderWrapper";
import FooterWrapper from "./Footer/FooterWrapper";
import TextMainBannerWrapper from "./TextMainBanners/TextMainBannerWrapper";

function SignUp() {
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    window.scrollTo(0, 0);
    handleRefresh();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await SendPostRequest("hospitals/department");
        if (res.status === "success" && res?.data && res?.data?.Departments) {
          const formattedOptions = res?.data?.Departments.map((department) => ({
            value: department,
            label: department,
          }));
        } else {
          console.error("Invalid or empty response from the API");
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchData();
  }, []);

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  const [captcha, setCaptcha] = useState("");
  const [input_captcha, setInputCaptcha] = useState("");
  const [check_captcha, setCheckCaptcha] = useState("");

  const navigate = useNavigate();

  const textColorClass =
    check_captcha === "Captcha Verified" ? "text-success" : "text-danger";
  const handleInputChange = (e) => {
    setInputCaptcha(e.target.value);
  };

  const handleRefresh = () => {
    const newCaptcha = generateRandomCaptcha();
    setCaptcha(newCaptcha);
  };

  const generateRandomCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const captchaLength = 6;
    let newCaptcha = "";

    for (let i = 0; i < captchaLength; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      newCaptcha += characters.charAt(randomIndex);
    }

    return newCaptcha;
  };

  const [inputValues, setInputValues] = useState({});
  const [gender, setGender] = useState(null);

  const [loading, setLoading] = useState(false);

  const handleGenderChange = (selectedOption) => {
    setGender(selectedOption.value);
  };

  const handleAllInputChange = (e) => {
    const { name, value } = e.target;

    // Special validation for age field
    if (name === "age") {
      // Only allow numbers between 1 and 120
      const ageValue = parseInt(value);
      if (value === "") {
        setInputValues(prevValues => ({
          ...prevValues,
          [name]: value
        }));
      } else if (!isNaN(ageValue) && ageValue >= 1 && ageValue <= 120) {
        setInputValues(prevValues => ({
          ...prevValues,
          [name]: ageValue.toString()
        }));
      }
      return;
    }

    // For all other fields
    setInputValues(prevValues => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValues?.full_name) {
      toast.error("Please enter your name");
      return;
    } else if (!gender) {
      toast.error("Please select your gender");
      return;
    } else if (!inputValues?.email) {
      toast.error("Please enter your email");
      return;
    } else if (
      !inputValues.email.includes(".") ||
      !inputValues.email.includes("@")
    ) {
      toast.error("Invalid email");
      return;
    } else if (!inputValues?.contact_number) {
      toast.error("Please enter your contact number ");
      return;
    } else if (inputValues.contact_number?.length !== 11) {
      toast.error("Invalid Number ");
      return;
    } else if (isNaN(inputValues?.contact_number)) {
      toast.error("Invalid number");
      return;
    } else if (!inputValues?.age) {
      toast.error("Please enter your age");
      return;
    } else if (isNaN(inputValues.age)) {
      toast.error("Age must be a number");
      return;
    } else if (inputValues.age < 1) {
      toast.error("Age must be greater than 0");
      return;
    } else if (!input_captcha) {
      toast.error("You haven't enter captcha");
      return;
    }
    const age = parseInt(inputValues.age);
    if (!inputValues.age || isNaN(age)) {
      toast.error("Please enter a valid age (1-120)");
      return;
    }
    if (age < 1 || age > 120) {
      toast.error("Age must be between 1 and 120");
      return;
    }

    if (captcha === input_captcha) {
      setLoading(true);
      setCheckCaptcha("Captcha Verified");

      try {
        const myallInputs = {
          ...inputValues,
          gender,
        };
        const response = await SendPostRequest("auth/signup", myallInputs);
        setInputValues({
          full_name: "",
          email: "",
          contact_number: "",
          age: "",
        });
        setLoading(false);
        setGender({ value: "" });
        handleRefresh();
        setInputCaptcha("");
        setCheckCaptcha("");
        // setInputCaptcha(null)
        setInputCaptcha([]);

        if (response?.status === "success") {
          toast.success(response?.message);
          navigate("/login");
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error("Something Went Wrong");
      }
    } else {
      setCheckCaptcha("Captcha failed");
      toast.error("Captcha verification failed");
    }
  };

  const [backgroundImage, setBackgroundImage] = useState("");
  let themeColor;
  if (sitedata) {
    themeColor = sitedata?.theme_color?.split(".css").join("");
  } else {
  }
  useEffect(() => {
    let themeColor;
    if (sitedata) {
      themeColor = sitedata?.theme_color?.split(".css").join("");
    } else {
    }

    setBackgroundImage(`/assets/img/doctors/banner_bg_${themeColor}.svg`);
  }, [sitedata?.theme_color]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Registration" Image="theme-2-banner-registration.webp" />
        {/* <div className="page-title-wrap typo-white">
          <div
            className="page-title-wrap-inner section-bg-img"
            data-bg="/assets/images/bg/page-title-bg.jpg"
            style={{
              backgroundImage: "url(/assets/images/bg/page-title-bg.jpg)",
            }}
          >
            <span className="black-overlay"></span>
            <div className="container">
              <div className="row text-center">
                <div className="col-md-12">
                  <div className="page-title-inner">
                    <div id="breadcrumb" className="breadcrumb mb-1 mb-lg-2">
                      <a href="index.html" className="theme-color">
                        Home
                      </a>
                      <span className="current">Pages</span>
                    </div>
                    <h1 className="page-title mb-0">Registration</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="content-wrapper pad-none">
          <div className="content-inner">

            {
              sitedata?.theme_registration_form === "colored" ? (
                <section id="section-contact" className="pad-top-5 pt-5 pb-2" style={{ background: "black" }}>
                  <div className="container" >
                    <div className="row">
                      {/* <div className="offset-md-2 col-md-8">
                    <div className="title-wrap text-center">
                      <div className="section-title">
                        <h2 className="title mb-0 text-uppercase text-white">
                          Register Your Account
                        </h2>
                      </div>
                    </div>
                  </div> */}
                      <div className="col-lg-12 align-self-center">
                        <div className="contact-form-4">
                          {/* <h3 className="title mb-3 heading-color-white">Sign Up</h3> */}
                          <div className="contact-form-wrap">
                            <form
                              id="contact-form"
                              className="contact-form bv-form"
                              action="inc/function.php"
                              enctype="multipart/form-data"
                              novalidate="novalidate"
                            >
                              <button
                                type="submit"
                                className="bv-hidden-submit"
                                style={{
                                  display: "none",
                                  width: "0px",
                                  height: "0px",
                                }}
                              ></button>
                              <div className="row">
                                <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 color-form-inputs">
                                  <label className="mb-0 heading-color-white fw-bold">Enter Full Name *</label>
                                  <input
                                    id="name"
                                    className="form-control"
                                    placeholder=""
                                    name="full_name"
                                    value={inputValues.full_name}
                                    onChange={handleAllInputChange}
                                    required
                                  />

                                </div>
                                <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 color-form-inputs">
                                  <label className="mb-0 heading-color-white fw-bold">Enter Contact Number *</label>
                                  <input
                                    type="text"
                                    className="input-name form-control"
                                    value={inputValues.contact_number}
                                    placeholder=""
                                    name="contact_number"
                                    onChange={handleAllInputChange}
                                    required
                                  />
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 color-form-inputs">
                                  <label className="mb-0 heading-color-white fw-bold">Enter Email Address *   <small className="text-mutede ms-2 text-white">(Email must be valid)</small></label>
                                  <input
                                    className="form-control"
                                    type="email"
                                    placeholder=""
                                    name="email"
                                    value={inputValues.email}
                                    onChange={handleAllInputChange}
                                    required
                                  />
                                </div>
                                {!isMobile ? (
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-2 color-form-inputs">
                                    <label className="mb-0 heading-color-white fw-bold">Captcha</label>
                                    <Captcha
                                      captcha={captcha}
                                      inputCaptcha={input_captcha}
                                      textColorClass={textColorClass}
                                      checkCaptcha={check_captcha}
                                      handleInputChange={handleInputChange}
                                    />
                                  </div>
                                ) : <div className="mb-2"></div>}

                                <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 color-form-inputs">
                                  <label className="mb-0 heading-color-white fw-bold">Enter Your Age *   <small className="text-mutede ms-2 text-white">(Age must be a number)</small></label>
                                  <input
                                    id="age"
                                    className="form-control mb-0"
                                    placeholder=""
                                    name="age"
                                    type="number"
                                    min="1"
                                    max="120"
                                    value={inputValues.age}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // Only allow digits between 1-120
                                      if (/^\d*$/.test(value) && (value === "" || (parseInt(value) >= 1 && parseInt(value) <= 120))) {
                                        setInputValues(prev => ({ ...prev, age: value }));
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      // Block 'e', 'E', '+', '-', and '.'
                                      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    required
                                  />
                                </div>
                                {isMobile ? (
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 color-form-select">
                                    <label className="mb-0 heading-color-white fw-bold">Select Gender *</label>
                                    <Select
                                      className="theme-2-gender-select them-2-gender-layout-mobile"
                                      name="gender"
                                      value={gender?.value}
                                      options={genderOptions}
                                      onChange={handleGenderChange}
                                      placeholder="Select"
                                      required
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: "white", // selected text white rahega
                                        }),
                                        placeholder: (base) => ({
                                          ...base,
                                          color: "white", // placeholder bhi white ho
                                        }),
                                        input: (base) => ({
                                          ...base,
                                          color: "white", // typing ke time bhi white ho
                                        }),
                                        option: (base) => ({
                                          ...base,
                                          color: "black", // keep options readable (default)
                                        }),
                                      }}
                                    />


                                  </div>
                                ) : null}
                                {isMobile ? (
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 color-form-inputs">
                                    <label className="mb-0 heading-color-white fw-bold">Captcha</label>
                                    <Captcha
                                      captcha={captcha}
                                      inputCaptcha={input_captcha}
                                      textColorClass={textColorClass}
                                      checkCaptcha={check_captcha}
                                      handleInputChange={handleInputChange}
                                    />
                                  </div>
                                ) : null}
                                <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 " style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                                {!isMobile ? (
                                    <label className="mb-0 fw-bold" style={{ visibility: "hidden" }}>Spacer</label>
                                ): null}
                                  <button
                                    style={{ height: "50px", padding: "0px 30px" }}
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    className=" mt-0  color-form-button"
                                  >
                                    <span>
                                      {loading ? "Please wait" : "Sign Up"}
                                    </span>
                                  </button>

                                </div>
                                {!isMobile ? (
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 color-form-select">
                                    <label className="mb-0 heading-color-white fw-bold">Select Gender *</label>
                                    <Select
                                      className="theme-2-gender-select"
                                      name="gender"
                                      value={gender?.value}
                                      options={genderOptions}
                                      onChange={handleGenderChange}
                                      placeholder="Select"
                                      required
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: "white", // selected text white rahega
                                        }),
                                        placeholder: (base) => ({
                                          ...base,
                                          color: "white", // placeholder bhi white ho
                                        }),
                                        input: (base) => ({
                                          ...base,
                                          color: "white", // typing ke time bhi white ho
                                        }),
                                        option: (base) => ({
                                          ...base,
                                          color: "black", // keep options readable (default)
                                        }),
                                      }}
                                    />


                                  </div>
                                ) : null}


                                <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3">
                                  <label className="mb-0 fw-bold" style={{ visibility: "hidden" }}>Spacer</label>

                                  <ul className="row cs_contact_info cs_style_1 cs_mp0" style={{ alignItems: "stretch" }}>
                                    <li className="col-lg-4 col-12" style={{ border: "none" }}>
                                      <h3 className="cs_fs_24 cs_semibold mb-0 heading-color-white " style={{ lineHeight: "1.8rem" }}>Phone</h3>
                                      <p className="cs_iconbox_subtitle mb-0  heading-color-white cs_heading_color">
                                        <a className="heading-color-white" href={`tel:${sitedata?.site_contact}`}>
                                          {sitedata?.site_contact}
                                        </a>
                                      </p>
                                    </li>

                                    {/* Vertical Line */}
                                    {!isMobile ? (
                                      <li className="col-lg-2 col-12">
                                        <div
                                          className="color-form-verticle-line"

                                        ></div>
                                      </li>
                                    ) : <div className="mb-2"></div>}


                                    <li className="col-lg-4 col-12">
                                      <h3 className="cs_fs_24 cs_semibold mb-0 heading-color-white " style={{ lineHeight: "1.8rem" }}>Email Us</h3>
                                      <p className="cs_iconbox_subtitle mb-0  heading-color-white cs_heading_color">
                                        <a className="heading-color-white" href={`mailto:${sitedata?.business_email || sitedata?.site_email}`}>
                                          {sitedata?.business_email || sitedata?.site_email}
                                        </a>
                                      </p>
                                    </li>
                                  </ul>


                                </div>






                                <div className="col-md-12">

                                </div>
                              </div>
                              <span className="clearfix"></span>
                            </form>
                            <div className="captcha-parent">
                              <div
                                className="g-recaptcha"
                                data-sitekey="6LcuIvEcAAAAAFnQUTIoRRn6Gvc54vbWAf0GSEdP"
                                data-callback="verifyRecaptchaCallback"
                              ></div>
                            </div>
                            <p id="contact-status-msg" className="hide"></p>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </section>
              ) : (
                <>
                  <section id="section-contact" className="pt-2 pb-0">
                    <div className="container">
                      <div className="row pt-4 mt-2 pb-2">

                        <div className="col-lg-12 align-self-center">
                          <div className="contact-form-4">
                            {/* <h3 className="title mb-3 ">Sign Up</h3> */}
                            <div className="contact-form-wrap">
                              <form
                                id="contact-form"
                                className="contact-form bv-form"
                                action="inc/function.php"
                                enctype="multipart/form-data"
                                novalidate="novalidate"
                              >
                                <button
                                  type="submit"
                                  className="bv-hidden-submit"
                                  style={{
                                    display: "none",
                                    width: "0px",
                                    height: "0px",
                                  }}
                                ></button>
                                <div className="row">
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 light-inputs-wrapper">
                                    <label className="mb-0 fw-bold">Enter Full Name *</label>
                                    <input
                                      id="name"
                                      className="form-control"
                                      placeholder="Enter Full Name"
                                      name="full_name"
                                      value={inputValues.full_name}
                                      onChange={handleAllInputChange}
                                      required
                                    />

                                  </div>
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 light-inputs-wrapper">
                                    <label className="mb-0 fw-bold">Enter Contact Number *</label>
                                    <input
                                      type="text"
                                      className="input-name form-control"
                                      value={inputValues.contact_number}
                                      placeholder="Enter Contact Number"
                                      name="contact_number"
                                      onChange={handleAllInputChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 light-inputs-wrapper">
                                    <label className="mb-0 fw-bold">Enter Email Address *  <small className="text-muted ms-2">(Email must be valid)</small></label>
                                    <input
                                      className="form-control"
                                      type="email"
                                      placeholder="Enter Email Address"
                                      name="email"
                                      value={inputValues.email}
                                      onChange={handleAllInputChange}
                                      required
                                    />
                                  </div>
                                   {isMobile ? (
                                    <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-0 light-select-wrapper">
                                      <label className="mb-0 fw-bold">Select Gender *</label>
                                      <Select
                                        className="theme-2-gender-select them-2-gender-layout-mobile"
                                        name="gender"
                                        value={gender?.value}
                                        options={genderOptions}
                                        onChange={handleGenderChange}
                                        placeholder="Select"
                                        required
                                        menuPortalTarget={document.body} // dropdown ko body me render karega
                                        styles={{
                                          menuPortal: base => ({ ...base, zIndex: 9999 }), // upar laane ke liye z-index
                                        }}
                                      />
                                    </div>
                                  ) : null}
                                  {/* <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 light-inputs-wrapper">
                                    <label className="mb-0 ">Captcha</label>
                                    <Captcha
                                      captcha={captcha}
                                      inputCaptcha={input_captcha}
                                      textColorClass={textColorClass}
                                      checkCaptcha={check_captcha}
                                      handleInputChange={handleInputChange}
                                    />
                                  </div> */}
                                  {!isMobile ? (
                                    <div className="col-lg-6 appointment_form_capcha mb-2 light-inputs-wrapper">
                                      <label className="mb-0 form-label fw-bold">Captcha</label>
                                      <Captcha
                                        captcha={captcha}
                                        inputCaptcha={input_captcha}
                                        textColorClass={textColorClass}
                                        checkCaptcha={check_captcha}
                                        handleInputChange={handleInputChange}
                                      />
                                    </div>
                                  ) : <div className="mb-3"></div>}

                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 light-inputs-wrapper">
                                    <label className="mb-0 fw-bold">Enter Your Age *   <small className="text-muted ms-2">(Age must be a number)</small></label>
                                    <input
                                      id="age"
                                      className="form-control mb-0"
                                      placeholder="Enter Your Age"
                                      name="age"
                                      type="number"
                                      min="1"
                                      max="120"
                                      value={inputValues.age}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        // Only allow digits between 1-120
                                        if (/^\d*$/.test(value) && (value === "" || (parseInt(value) >= 1 && parseInt(value) <= 120))) {
                                          setInputValues(prev => ({ ...prev, age: value }));
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        // Block 'e', 'E', '+', '-', and '.'
                                        if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      required
                                    />
                                  </div>
                                  
                                  {isMobile ? (
                                    <div className="col-lg-6 appointment_form_capcha mb-2 light-inputs-wrapper">
                                      <label className="mb-0 form-label fw-bold">Captcha</label>
                                      <Captcha
                                        captcha={captcha}
                                        inputCaptcha={input_captcha}
                                        textColorClass={textColorClass}
                                        checkCaptcha={check_captcha}
                                        handleInputChange={handleInputChange}
                                      />
                                    </div>
                                  ) : null}
                                 
                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3  " style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                                    {!isMobile ? (
                                      <label className="mb-0 fw-bold" style={{ visibility: "hidden" }}>Spacer</label>
                                    ) : null}
                                    <button
                                      style={{ height: "50px", padding: "0px 30px" }}
                                      onClick={handleSubmit}
                                      disabled={loading}
                                      className=" mt-0  btn btn-default"
                                    >
                                      <span>
                                        {loading ? "Please wait" : "Sign Up"}
                                      </span>
                                    </button>

                                  </div>
                                  {!isMobile ? (
                                    <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3 light-select-wrapper">
                                      <label className="mb-0 fw-bold">Select Gender *</label>
                                      <Select
                                        className="theme-2-gender-select"
                                        name="gender"
                                        value={gender?.value}
                                        options={genderOptions}
                                        onChange={handleGenderChange}
                                        placeholder="Select"
                                        required
                                        menuPortalTarget={document.body} // dropdown ko body me render karega
                                        styles={{
                                          menuPortal: base => ({ ...base, zIndex: 9999 }), // upar laane ke liye z-index
                                        }}
                                      />
                                    </div>
                                  ) : null}


                                  <div className="col-lg-6 col-md-6 col-12 form-group has-feedback mb-3">
                                    {!isMobile ? (
                                      <label className="mb-0 fw-bold" style={{ visibility: "hidden" }}>Spacer</label>
                                    ) : null}

                                    <ul className="row cs_contact_info cs_style_1 cs_mp0" style={{ alignItems: "stretch" }}>
                                      <li className="col-lg-4 col-12" style={{ border: "none" }}>
                                        <h3 className="cs_fs_24 cs_semibold mb-0 " style={{ lineHeight: "1.8rem" }}>Phone</h3>
                                        <p className="cs_iconbox_subtitle mb-0  cs_heading_color">
                                          <a className="" href={`tel:${sitedata?.site_contact}`}>
                                            {sitedata?.site_contact}
                                          </a>
                                        </p>
                                      </li>

                                      {/* Vertical Line */}
                                      <li className="col-lg-2 col-12">
                                        <div
                                          className="light-form-verticle-line"

                                        ></div>
                                      </li>

                                      <li className="col-lg-4 col-12">
                                        <h3 className="cs_fs_24 cs_semibold mb-0 " style={{ lineHeight: "1.8rem" }}>Email Us</h3>
                                        <p className="cs_iconbox_subtitle mb-0  cs_heading_color">
                                          <a className="" href={`mailto:${sitedata?.business_email || sitedata?.site_email}`}>
                                            {sitedata?.business_email || sitedata?.site_email}
                                          </a>
                                        </p>
                                      </li>
                                    </ul>


                                  </div>






                                  <div className="col-md-12">

                                  </div>
                                </div>
                                <span className="clearfix"></span>
                              </form>
                              <div className="captcha-parent">
                                <div
                                  className="g-recaptcha"
                                  data-sitekey="6LcuIvEcAAAAAFnQUTIoRRn6Gvc54vbWAf0GSEdP"
                                  data-callback="verifyRecaptchaCallback"
                                ></div>
                              </div>
                              <p id="contact-status-msg" className="hide"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )}

          </div>
        </div>
        <FooterWrapper />
      </div>
    </div>
  );
}

export default SignUp;
